<template>
<div>
  <van-nav-bar
    title="佣金明细"
    left-text="返回"
    left-arrow
    @click-left="onClickLeft"
  />
  <van-list
    v-model:loading="loading"
    :finished="finished"
    finished-text="没有更多了"
    @load="onLoad"
  >
    <div class="rebate-box">
      <div class="title rebate-item">
        <div class="number">号码</div>
        <div class="money">订单金额</div>
        <div class="money">佣金</div>
        <div class="date">时间</div>
      </div>
      <div class="rebate-item" v-for="(item,index) in datalist" :key="index">
        <div class="number">{{item.order.order_sn}}</div>
        <div class="money">{{item.order.price}}</div>
        <div class="money">{{item.money}}</div>
        <div class="date">{{item.createTime.substr(0,10)}}</div>
      </div>
    </div>
  </van-list>
</div>
</template>

<script>
    export default {
        name: "rebatelist",
        data(){
          return {
            loading:false,
            finished:false,
            page:1,
            userInfo:{},
            datalist:[]
          }
        },
      created() {

      },
      methods: {
        onLoad(){
          this.fetchData("/rebate/queryListByAgent/",{page:this.page},res=>{
            if(res.code){
              if(this.page>=res.data.last_page){
                this.finished = true
              }
              this.page++;
              this.loading = false
              this.datalist.push(...res.data.data)
            }
          })
        },
          onClickLeft() {
            this.$router.back()
          },
        }
    }
</script>

<style scoped lang="scss">
  .rebate-box {
    padding: 0 .4rem;
    font-size: 0!important;
    .title{
      font-weight: bolder;
    }
    .rebate-item {
      display: block;
      padding: .12rem 0;
      border-bottom: 1px solid #eee;
      div {
        font-size: 0;
        display: inline-block;
        text-align: left;
      }
      .number{
        width: 3.0rem;
        font-size: 0.24rem;
      }
      .money{
        width: 1.1rem;
        font-size: 0.24rem;
        text-align: center;
      }
      .date{
        width: 1.5rem;
        text-align: right;
        font-size: 0.24rem;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/rebatelist.vue